// get the API result via jQuery.ajax
const countryCode = window.localStorage.getItem('PSCountry');
const countryCurrency = window.localStorage.getItem('PSCurrency');
const currentSite =
  window.PSTheme.Settings.CurrentSite || window.Shopify.country;

function selectedGeo(countryCurrency) {
  const hideGeoPop = document.querySelector('.geolocation_custom');
  hideGeoPop.innerHTML = '';
  // eslint-disable-next-line no-unused-expressions
  hideGeoPop.hide;
  document.body.classList.add('currency-selected');
}

function setGeoClass(location) {
  const showGeoPop = document.querySelector('.geolocation_custom');
  showGeoPop.style.display = 'flex';

  if (location === 'NZ') {
    // NZ and rest of world
    document.body.classList.add('nz-site');

    const currency = document.querySelectorAll('.currency_selector button');
    currency.forEach((btn) => {
      btn.addEventListener('click', () => {
        window.location.href = btn.dataset.url || window.location.href;
        btn.classList.add('selected');
        window.localStorage.setItem('PSCurrency', btn.value);
      });
    });

    const closePopup = document.querySelector('.close_geo');
    closePopup.addEventListener('click', () => {
      // eslint-disable-next-line no-self-assign
      window.location.href = window.location.href;
      window.localStorage.setItem('PSCurrency', 'NZ');
      document.body.classList.add('currency-selected');
    });
  } else if (location === 'GB') {
    document.body.classList.add('uk-site');

    const currency = document.querySelectorAll('.currency_selector button');
    currency.forEach((btn) => {
      btn.addEventListener('click', () => {
        window.location.href = btn.dataset.url || window.location.href;
        btn.classList.add('selected');
        window.localStorage.setItem('PSCurrency', btn.value);
      });
    });

    const closePopup = document.querySelector('.close_geo');
    closePopup.addEventListener('click', () => {
      // eslint-disable-next-line no-self-assign
      window.location.href = window.location.href;
      window.localStorage.setItem('PSCurrency', 'GB');
      document.body.classList.add('currency-selected');
    });
  } else {
    // USA only
    document.body.classList.add('us-site');

    const currency = document.querySelectorAll('.currency_selector button');
    currency.forEach((btn) => {
      btn.addEventListener('click', () => {
        window.location.href = btn.dataset.url || window.location.href;
        btn.classList.add('selected');
        window.localStorage.setItem('PSCurrency', btn.value);
      });
    });

    const closePopup = document.querySelector('.close_geo');
    closePopup.addEventListener('click', () => {
      // eslint-disable-next-line no-self-assign
      window.location.href = window.location.href;
      window.localStorage.setItem('PSCurrency', 'US');
      document.body.classList.add('currency-selected');
    });
  }
}

if (countryCurrency) {
  selectedGeo(countryCurrency);
} else {
  fetch('/browsing_context_suggestions.json')
    .then((res) => res.json())
    .then((data) => {
      window.localStorage.setItem(
        'PSCountry',
        data.detected_values.country.handle
      );
      if (data.detected_values.country.handle === currentSite) {
        window.localStorage.setItem(
          'PSCurrency',
          data.detected_values.country.handle
        );
      } else {
        setGeoClass(data.detected_values.country.handle);
      }
    })
    .catch((error) => {
      // Handle error
      // eslint-disable-next-line no-console
      console.error('error', error);
    });
}
